<template>
    <v-row>
        <v-col cols="12">
            <v-card class="justify-center">
                <v-card-text class="justify-center text-center">
                    <p class="text-h4 text--primary">
                        Профессиональное сопровождение ГИС ЖКХ
                    </p>
                    <p class="text-h4 text--primary">
                        Заполнение на 100%
                    </p>
                    <p class="text-h5 text--primary">Просто посмотрите видео!</p>
                    <p>
                        <iframe
                            width="560"
                            height="315"
                            src="https://rutube.ru/play/embed/f76adb7defa16838828e0bc55f09c3a9/?p=mnCyW770ieMppt6FnNHpKw"
                            frameBorder="0"
                            allow="clipboard-write; autoplay"
                            webkitAllowFullScreen
                            mozallowfullscreen
                            allowFullScreen>
                        </iframe>
                    </p>
                    <p class="text--primary">
                        Подробнее об услуге <br/> 
                        Можно прочитать <a target="_blank" href="https://gis.ais24.ru/?utm_source=web&utm_medium=ais24&utm_campaign=lk&utm_content=gis">тут>></a>
                    </p>
                    <v-btn color="success" @click="(dialog = true)">Оставить заявку</v-btn>
    

                </v-card-text>
            </v-card>
        </v-col>
        <v-row>
            <v-col cols="12">
                <v-dialog
                    max-width="600"
                    v-model="dialog"
                >
                    <template v-slot:default="dialog">
                        <v-card>
                            <v-toolbar
                                color="primary"
                                dark
                            >Отправить заявку
                            </v-toolbar>
                            <v-card-text>
                                <v-form
                                    ref="form"
                                    v-model="valid"
                                    lazy-validation
                                >
                                    <v-text-field
                                        v-model="form.username"
                                        :rules="[v => !!v || 'Имя обязательно к заполнению']"
                                        label="Ваше имя"
                                        class="mb-4 mt-4"
                                        required
                                    ></v-text-field>
                                    <v-text-field
                                        :label="'Номер телефона'"
                                        v-mask="'+7 (###) ### ## ##'"
                                        :rules="[v => !!v || 'Телефон обязателен к заполнению', 
                                                 v => v.replace(/\D/g, '').length == 11 || 'Неверный формат телефона']"
                                        class="mb-4"
                                        dense
                                        v-model="form.phone"
                                        persistent-hint>
                                    </v-text-field>
                                </v-form>
                            </v-card-text>
                            <v-card-actions class="justify-end">
                                <v-btn
                                    color="success"
                                    class="mr-4"
                                    @click="onSubmitOrder"
                                    :disabled="formFetch"
                                >
                                    Отправить
                                </v-btn>
                                <v-btn
                                    text
                                    @click="dialog.value = false"
                                >Закрыть</v-btn>
                            </v-card-actions>
                        </v-card>
                    </template>
                </v-dialog>
            </v-col>
        </v-row>
    </v-row>
</template>
  
<script>
    import axios from '@/plugins/axios';
    import { mapGetters, mapActions } from 'vuex';
    export default {
        name: 'MaintenancePage',
        props: {
        },
        created(){
            this.form.username = this.USER_FULL_NAME;
            if(this.CONTACT_PHONES.length > 0){
                this.form.phone = this.CONTACT_PHONES[0];
            }
        },
        data() {
            return {
                dialog: false,
                valid: true,
                form: {
                    username: "",
                    phone: "",
                },
                formFetch: false
            }
        },
        methods: {
            ...mapActions('notifications', ['SHOW_ERROR', 'SHOW_SUCCESS']),
            onSubmitOrder(){
                if( ! this.$refs.form.validate() ){
                    return;
                }
                this.formFetch = true;
                axios.post('/maintenance/order', this.form)
                    .then(res => {
                        this.SHOW_SUCCESS(res.data.message);
                        this.dialog = false;
                        this.resetForm();
                    }).catch(err => {
                        console.log(err);
                        this.SHOW_ERROR('Произошла ошибка. Повторите попытку');
                    }).finally(() => {
                        this.formFetch = false;
                    });
            },
            resetForm(){
                this.form.username = "";
                this.form.phone = "";
                this.$refs.form.resetValidation()
            }
        },
        computed: {
            ...mapGetters('user', ['CONTACT_PHONES', 'USER_FULL_NAME']),
        }
    };
</script>